import { render, staticRenderFns } from "./InventoryConfigurator.vue?vue&type=template&id=096293e4&"
import script from "./InventoryConfigurator.vue?vue&type=script&lang=js&"
export * from "./InventoryConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports